import { IGtag } from "application";
import { useEffect } from "react";
import { ShippingOptions } from "typing";

export const cleanShippingText = (value: string): string => {
  return value
    .replace(/ias úteis/g, "")
    .replace(/ia útil/g, "")
    .replace(/ora útil/g, "")
    .replace(/oras úteis/g, "")
    .replace(/ /g, "");
};

export const removeQuotationAndBrackets = (value: string) => {
  if (!value) {
    return "";
  }
  return value.replace(/"/g, "").replace(/[[\]]/g, "");
};

export const findStoreId = (branch: string) => {
  switch (branch) {
    case "GARANHUNS":
      return "1";
    case "IMBIRIBEIRA":
      return "2";
    case "PARALELA":
      return "3";
    case "TAMARINEIRA":
      return "4";
    case "ARACAJU":
      return "5";
    case "JOAO PESSOA":
      return "6";
    case "PONTA NEGRA":
      return "7";
    case "CARUARU":
      return "8";
    case "BARRIS":
      return "9";
    default:
      return "0";
  }
};

export const calculateDaysUntilArrival = (arrivalDate: string): string => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const arrivalDateFormatted = new Date(arrivalDate);
  const timeDifference = arrivalDateFormatted.getTime() - today.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  const daysDifferenceWithoutToday = daysDifference - 1;

  return daysDifference > 0 ? `${daysDifferenceWithoutToday.toString()}d` : "0";
};
export const useGtagViewShippingOptions = (
  gtag: IGtag,
  data: ShippingOptions[] | null | undefined,
  zipCode: string,
  description: string | undefined,
  idProduct: string | number | undefined
): void => {
  useEffect(() => {
    if (data !== undefined) {
      const fcShippingOptions =
        data?.length &&
        data.map((item) =>
          // v: valor, l: loja, p: prazo, t: tipo de entrega
          item?.pickUpInStore
            ? {
                l: findStoreId(item?.pickUpInStoreLocation?.store),
                p: cleanShippingText(item?.arrivesTextShort || ""),
              }
            : item?.arrivesTextShort?.includes("dias") ||
              item?.arrivesTextShort?.includes("dia")
            ? {
                v: item?.value,
                p: calculateDaysUntilArrival(item?.arrives || ""),
                t: item?.description?.substring(0, 2),
              }
            : {
                v: item?.value,
                p: cleanShippingText(item?.arrivesTextShort || ""),
                t: item?.description?.substring(0, 2),
              }
        );
      const fcShippingOptionsString = data?.length
        ? JSON.stringify(fcShippingOptions)
        : "Sem opções de entrega e retirada";
      gtag?.viewProductShipping(
        String(idProduct),
        String(description),
        String(zipCode),
        removeQuotationAndBrackets(fcShippingOptionsString)
      );
    }
  }, [data, zipCode, description, idProduct, gtag]);
};
